var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "panel-body mt-4" }, [
    _vm.cur_step === "select_type"
      ? _c("div", { staticClass: "step_choose" }, [
          _c(
            "ul",
            { staticClass: "row imc_box" },
            _vm._l(_vm.declaration_info.allowed_types, function (item) {
              return _c(
                "li",
                {
                  key: item && item.id ? item.id : item,
                  staticClass: "mt-3 mb-3 col-md-4 col-xs-6 col-lg-3 col-xl-2",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.show_agree(item)
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "bg-primary-500 color-primary-500",
                      attrs: { href: "#" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "menu_item rounded hover-bg shadow-hover text-center shadow-sm border",
                        },
                        [
                          _vm._m(0, true),
                          _vm._v(" "),
                          _c("div", { staticClass: "content" }, [
                            _c("h5", { staticClass: "name" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(item && item.name ? item.name : item) +
                                  "\n                            "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.cur_step === "agree"
      ? _c("div", { staticClass: "agree" }, [
          _c("div", { staticClass: "panel-tag mt-2" }, [
            _vm._v(
              "\n            Ця анкета не є перевіркою на доброчесність. Це інструмент захисту вашої репутації.\n            Наявність відповіді «ТАК» не означає порушення, це означає необхідність прозорості.\n            Будь ласка, дайте відповідь на наступні питання стосовно себе та ваших Пов’язаних осіб\n            (чоловік/дружина, діти, батьки, рідні брати/сестри)\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-5 pb-5 mt-5 pb-5" },
            [
              _c("b-form-radio-group", {
                attrs: {
                  id: "btn-radios-1",
                  "button-variant": "outline-primary",
                  options: _vm.addon_options,
                  name: "radios-btn-default",
                  buttons: "",
                },
                model: {
                  value: _vm.agree,
                  callback: function ($$v) {
                    _vm.agree = $$v
                  },
                  expression: "agree",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "desclimer mt-2" }, [
                _vm._v(
                  "\n                Я підтверджую достовірність наданих даних та надаю згоду на їх обробку. Я усвідомлюю, що надана мною інформація містить персональні дані. Відповідно до Закону України «Про захист персональних даних», я надаю згоду на обробку цієї інформації з метою врегулювання конфлікту інтересів. Щодо переданих мною персональних даних третіх осіб (Пов’язаних осіб), я підтверджую, що маю законні підстави для передачі такої інформації роботодавцю, і що ці особи повідомлені про таку передачу.\n            "
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3 pl-0 ml-0 mt-5",
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-lg btn-block btn-success waves-effect waves-themed",
                  attrs: { disabled: !_vm.agree },
                  on: { click: _vm.show_anketa },
                },
                [
                  _c("span", { staticClass: "fal fa-download mr-1" }),
                  _vm._v("\n                Розпочати\n            "),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.cur_step === "anketa"
      ? _c(
          "div",
          { staticClass: "anketa" },
          [
            _c(
              "b-overlay",
              {
                attrs: {
                  show: _vm.is_load,
                  rounded: "sm",
                  opacity: "0.6",
                  "spinner-small": "",
                  "spinner-variant": "primary",
                },
              },
              [
                _vm.items && _vm.items.length
                  ? _c(
                      "div",
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-wrap align-items-center justify-content-between mb-3",
                          },
                          [
                            _c("div", { staticClass: "mr-3" }, [
                              _c("div", { staticClass: "font-weight-bold" }, [
                                _vm._v("Декларування конфлікту інтересів"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "text-muted small" }, [
                                _vm._v(
                                  "\n                            Відповіді: " +
                                    _vm._s(_vm.answeredVisibleCount) +
                                    " / " +
                                    _vm._s(_vm.visibleCount) +
                                    "\n                            "
                                ),
                                _vm.visibleCount
                                  ? _c("span", [
                                      _vm._v(
                                        " (" +
                                          _vm._s(_vm.progressPercent) +
                                          "%)"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-secondary mr-2",
                                    attrs: { type: "button" },
                                    on: { click: _vm.toggleAllBlocks },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.allBlocksOpened
                                            ? "Згорнути блоки"
                                            : "Розгорнути блоки"
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showErrors && !_vm.canSubmit
                          ? _c("div", { staticClass: "alert alert-danger" }, [
                              _vm._v(
                                "\n                    Перевірте відповіді: усі видимі питання мають бути заповнені, а обов’язкові коментарі — внесені.\n                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.items, function (block) {
                          return _c(
                            "div",
                            { key: block.group_type, staticClass: "mb-4" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "block-head d-flex align-items-center justify-content-between",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleBlock(block.group_type)
                                    },
                                  },
                                },
                                [
                                  _c("h4", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(block.group_name)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "text-muted small" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.blockProgress(block)) +
                                          "\n                            "
                                      ),
                                      _c("i", {
                                        staticClass: "fal",
                                        class: _vm.isBlockOpen(block.group_type)
                                          ? "fa-chevron-up"
                                          : "fa-chevron-down",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isBlockOpen(block.group_type),
                                      expression:
                                        "isBlockOpen(block.group_type)",
                                    },
                                  ],
                                  staticClass: "mt-3",
                                },
                                _vm._l(block.items, function (step) {
                                  return _c("StepNode", {
                                    key: step.id,
                                    attrs: {
                                      node: step,
                                      answers: _vm.answers,
                                      yesNoOptions: _vm.yesNoOptions,
                                      isVisible: _vm.isVisible,
                                      isCommentRequired: _vm.isCommentRequired,
                                      showErrors: _vm.showErrors,
                                      indexMap: _vm.indexMap,
                                    },
                                    on: {
                                      setAnswer: _vm.setAnswer,
                                      setComment: _vm.setComment,
                                    },
                                  })
                                }),
                                1
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt-4" },
                          [
                            _c(
                              "b-overlay",
                              { attrs: { show: _vm.is_saving } },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-lg btn-block btn-success",
                                    attrs: { disabled: !_vm.canSubmit },
                                    on: { click: _vm.submitAnketa },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Надіслати\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  : _c("div", { staticClass: "text-muted p-3" }, [
                      _vm._v(
                        "\n                Немає питань для відображення\n            "
                      ),
                    ]),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "fal fa fa-file" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }